import $ from 'jquery';
import { mapa1, mapa2, mapa3 } from './data/maps3Data.js';

//render map info

let map = mapa1;

const $mapGroup = $('.interactive_map_graph_group');
const $map1 = $('.map1_thumb');
const $map2 = $('.map2_thumb');
const $map3 = $('.map3_thumb');
const $mapTitle = $('.map_graph_title');
const $info = $('.info')

$map1.on('click', mapStart1);
$map2.on('click', mapStart2);
$map3.on('click', mapStart3);

function mapStart1() {
  map = mapa1
  renderMap('infantis')
  cleanAndAddTitle('infantis')
  $mapGroup.addClass('map1')
}

function mapStart2() {
  map = mapa2
  renderMap('maternos')
  cleanAndAddTitle('maternos')
  $mapGroup.addClass('map2')
}

function mapStart3() {
  map = mapa3
  renderMap('fetais')
  cleanAndAddTitle('fetais')
  $mapGroup.addClass('map3')
}

function cleanAndAddTitle(dead) {
  $mapGroup.removeClass('map1')
  $mapGroup.removeClass('map2')
  $mapGroup.removeClass('map3')

  addTitle(`óbitos ${dead} em 2015`)

  $info.removeClass('show_info')
  $('.region').removeClass('on')
  $('.region_ball').removeClass('active')
}

function addTitle(string) {
  $mapTitle.empty()
  $mapTitle.append(
    string
  )
}

let $thisMapType 

function renderMap(type){

  let dictionary;

  const mother = {
    singular: 'materna',
    plural: 'maternas',
    nascimentos: 'nascidos vivos'
  }

  const child = {
    singular: 'infantil',
    plural: 'infantis',
    nascimentos: 'nascidos vivos'
  }

  const fetus = {
    singular: 'fetal',
    plural: 'fetais',
    nascimentos: 'nascimentos'
  }

  if(type == 'maternos') {
    dictionary = mother;
  }

  if(type == 'infantis') {
    dictionary = child;
  }

  if(type == 'fetais') {
    dictionary = fetus;
  }

  for( var region in map) {


    let $region = $(`.info.${region}`);
    let results = map[`${region}`]['resultados'];

    $region.empty();

    $region.append(

      '<div class="region_ball_wrap" >' +
      '<div class="region_ball" style="width:' + map[`${region}`]['proportion'] + '%; height:' + map[`${region}`]['proportion'] + '%;">' + 
      '<div class="region_ball_name">' + map[`${region}`]['regionName'] + '</div>' +
      '</div>' +
      '</div>' +

      '<div class="info_balls_wrap">' +
      '<div class="info_balls alive" style="width:' + results[0]['percentage'] + '%; height:' + results[0]['percentage'] + '%;">' +
      '<div class="info_balls_number">' + results[0]['number'] + '</div>' +
      '<div class="info_balls_text">' + dictionary['nascimentos'] + '</div>' +
      '</div>' +
      '</div>' +
    
      '<div class="info_balls_wrap">' +
      '<div class="info_balls mother_death" style="width:' + results[1]['percentage'] + '%; height:' + results[1]['percentage'] + '%;">' +
      '<div class="info_balls_number">' + results[1]['number'] + '</div>' +
      '<div class="info_balls_text">ÓBITOS ' + dictionary['plural'] + '</div>' + 
      '</div>' +
      '</div>' +
    
      '<div class="info_balls_wrap">' +
      '<div class="info_balls ratio" style="width:' + results[2]['percentage'] + '%; height:' + results[2]['percentage'] + '%;">' +
      '<div class="info_balls_number">' + results[2]['number'] + '</div>' +
      '<div class="info_balls_text">RAZÃO MORTE ' + dictionary['singular'] + ' <div class="ball_more_info">(POR 100.000 NASCIDOS VIVOS)</div></div>' +
      '</div>' +
      '</div>'
    );
  }
}

renderMap('infantis');

// interactivity in big map

const $mapRegion = $('.region')
const $mapBall = $('.region_ball')
const $brasil = $('.brasil')
const $brasilName = $('.brasil .region_ball_name')
const $mapGraph = $( '.interactive_map_graph' )
const $startCover = $('.start_cover')

$info.on({
  click: moreInfoBallClick
})

$mapRegion.on({
  click: moreInfoMapClick
})

$brasil.on('click', showAllInfoBalls)

$startCover.on('click', showAllInfoBalls)

function showAllInfoBalls(){
  $mapGraph.toggleClass('map_start');
  $startCover.toggleClass('show');
  $info.removeClass('show_info')
}

$mapGraph.click((e) => {
  if ($(e.target).is('.region_ball, .region_ball_wrap, .region_ball_name')) {
    return;
  } else {
    $info.removeClass('show_info')
  }
});

let $thisInfo

// on click na bola

function moreInfoBallClick() {
  if ($(this).hasClass('brasil')) {
    return;
  }

  $info.removeClass('show_info')
  $(this).addClass('show_info')
}

// on click no mapa

let thisMap

function moreInfoMapClick() {

  thisMap = $(this).attr('class').split(' ')[0]
  $thisInfo = $(`.info.${thisMap}`)

  $info.removeClass('show_info')
  $thisInfo.addClass('show_info')

}



